








































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {changePassword} from "@/modules/auth/service";
import {AuthStore} from "@/modules/auth/store";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";

const form = {
    oldPassword: "",
    password: "",
    passwordConfirm: ""
}
@Component({
    name: "ChangePassword",
    components: {AInputCustom}
})
export default class extends mixins(CommonMixin) {
    isSubmitting = false;
    form = {...form};
    validateOldPass = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('Nhập mật khẩu hiện tại'));
        } else {
            callback();
        }
    };
    validatePass = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('Nhập mật khẩu mới'));
        } else {
            if (this.form.passwordConfirm !== '') {
                (this.$refs.changePassForm as any).validateField('passwordConfirm');
            }
            callback();
        }
    };
    validatePassConfirm = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('Nhập lại mật khẩu mới'));
        } else if (value !== this.form.password) {
            callback(new Error("Mật khẩu không khớp"));
        } else {
            callback();
        }
    };
    rules = {
        oldPassword: [{ validator: this.validateOldPass, trigger: "change" }],
        password: [{ validator: this.validatePass, trigger: "change" }],
        passwordConfirm: [{ validator: this.validatePassConfirm, trigger: "change" }]
    };

    changePassword() {
        (this.$refs.changePassForm as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                this.isSubmitting = true;
                await changePassword(this.form);
                this.$message.success("Đổi mật khẩu thành công, đăng nhập lại để sử dụng");
                setTimeout(() => {
                    AuthStore.logout();
                }, 1000)
            } catch (e) {
                this.$message.error(e?.response?.data?.message || "Đổi mật khẩu thất bại");
            } finally {
                this.isSubmitting = false;
            }
        })
    }
}
